import { useCallback, useEffect, useState } from 'react';
import { message } from 'antd';
import { FIND, process } from '../Service/Api';
import { apiKey, getServer } from '../Utils/url';
import axios from 'axios';

export const useFetchOrders = (queries = '', skip = 0, limit = 10) => {
  const [data, setData] = useState({ data: [] });
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState({ queries, limit, skip });

  const getOrders = useCallback(async () => {
    setLoading(true);
    const response = await process(FIND, 'orders', {}, params);
    if (response?.ok) {
      setData(response.data);
    } else {
      message.error('Error al consultar ordenes');
    }
    setLoading(false);
  }, [process, params]);

  useEffect(() => {
    getOrders();
  }, [getOrders]);

  const onChangeParams = (q = '', s = 0, l = 10) =>
    setParams({ queries: q, limit: l, skip: s });

  const update = () => getOrders();

  return [data, loading, onChangeParams, update];
};

export const useFetchOrdersWithApiKey = (
  queries = '',
  skip = 0,
  limit = 10
) => {
  const [data, setData] = useState({ data: [] });
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState({ queries, limit, skip });
  const baseURL = getServer();
  const key = apiKey();

  const getOrders = useCallback(async () => {
    setLoading(true);
    let response;
    try {
      const config = {
        method: 'get',
        maxBodyLength: 'Infinity',
        url: `${baseURL}/orders?${params.queries ? params.queries + '&' : ''}${
          params.limit ? '$limit=' + params.limit : ''
        }&$skip=${params.skip}`,
        headers: {
          'x-api-key': key,
        },
      };
      response = await axios(config);
      if (response.status === 200) {
        console.log('response:', response);
      }
    } catch (error) {
      message.error('Error al intentar obtener los tickets');
    }
    if (response) {
      setData(response.data);
    } else {
      message.error('Error al consultar ordenes');
    }
    setLoading(false);
  }, [process, params]);

  useEffect(() => {
    getOrders();
  }, [getOrders]);

  const onChangeParams = (q = '', s = 0, l = 10) =>
    setParams({ queries: q, limit: l, skip: s });

  const update = () => getOrders();

  return [data, loading, onChangeParams, update];
};

export const usePatchOrdersWithApiKey = async (orderData, orderId) => {
  const baseURL = getServer();
  const key = apiKey();

  let response;
  try {
    const config = {
      method: 'patch',
      maxBodyLength: 'Infinity',
      url: `${baseURL}/orders/${orderId}`,
      headers: {
        'x-api-key': key,
      },
      data: orderData,
    };
    response = await axios(config);
  } catch (error) {
    message.error('Error al intentar modificar la orden');
  }
  if (response) {
    return response;
  } else {
    message.error('Error al modificar la orden');
  }
};
